// What both Activity tabs share: the time-range choices and row formatting.

export const TIME_RANGES = [
  { id: "1h", label: "Last hour", ms: 3_600_000 },
  { id: "24h", label: "Last 24 hours", ms: 86_400_000 },
  { id: "7d", label: "Last 7 days", ms: 7 * 86_400_000 },
  { id: "30d", label: "Last 30 days", ms: 30 * 86_400_000 },
  { id: "all", label: "All time", ms: 0 },
];

/** ISO lower bound for a range id ("" for all time / unknown). */
export function sinceFor(range, now = Date.now()) {
  const r = TIME_RANGES.find((t) => t.id === range);
  return r && r.ms ? new Date(now - r.ms).toISOString() : "";
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? String(iso) : d.toLocaleString(undefined, { hour12: false });
}

export function fmtJson(value) {
  if (value === null || value === undefined) return "";
  try {
    return JSON.stringify(value, null, 2);
  } catch (_error) {
    return String(value);
  }
}
